export default window.screenfull || { enabled: false };